export { mytenderUrl, openExternal } from "@/agents-v2/utils/open-external";
